<template>
    <!-- 次卡 -->	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
                <!-- <el-form-item v-show="dataTypeShow" >
                <el-input-number  v-model="limitValue" :min="0" :max="20000"></el-input-number>
				</el-form-item> -->
 				<el-form-item v-if="TenancyId=='0'||TenancyId==null">
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" @change="ChangeList" >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				 
                </el-form-item>               
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="List" placeholder="姓名"></el-input>
				</el-form-item>						
                <el-form-item>
                    <div class="block">
                   <el-date-picker
				   placeholder="选择日期"
                        v-model="dateValue" 
                         type="daterange"                       
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                   </el-date-picker>
                    </div>
                   </el-form-item>													
				<el-form-item>					
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getData" icon="el-icon-search">查询</el-button>
					<el-button size="width:100%; height:100%;" type="warning" :loading="reportLoading" v-on:click="exportReport" icon="el-icon-search">导出</el-button>
				</el-form-item>

			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="List" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column prop="Rownumber" width="120">
			</el-table-column> -->
			<el-table-column prop="ShopName" label="门店" width="180" sortable>
			</el-table-column>
			<el-table-column prop="UserName" label="水质检测员" width="180" sortable>
			</el-table-column>			
			<el-table-column prop="DateTime" label="检测时间" width="180" sortable>
			</el-table-column>
			<el-table-column prop="TemperaturePool1" label="池1水温" width="180" sortable>
			</el-table-column>
			<el-table-column prop="ChlorinePool1" label="池1余氯" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="PHPool1" label="池1PH值" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="FootPool1" label="池1浸脚池" width="180" sortable>
			</el-table-column>
			</el-table-column>
			<el-table-column  label="池1图1" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrlPool1!=null"  @click="see(scope.row.ImageUrlPool1)"  :src="image(scope.row.ImageUrlPool1)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>
			<el-table-column  label="池1图2" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image2UrlPool1!=null"  @click="see(scope.row.Image2UrlPool1)"  :src="image(scope.row.Image2UrlPool1)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>										
			<el-table-column  label="池1图3" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image3UrlPool1!=null"  @click="see(scope.row.Image3UrlPool1)"  :src="image(scope.row.Image3UrlPool1)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>													
			<el-table-column prop="TemperaturePool2" label="池2水温" width="180" sortable>
			</el-table-column>
			<el-table-column prop="ChlorinePool2" label="池2余氯" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="PHPool2" label="池2PH值" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="FootPool2" label="池2浸脚池" width="180" sortable>
			</el-table-column>	
			<el-table-column  label="池2图1" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrlPool2!=null"  @click="see(scope.row.ImageUrlPool2)"  :src="image(scope.row.ImageUrlPool2)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>	
			<el-table-column  label="池2图2" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image2UrlPool2!=null"  @click="see(scope.row.Image2UrlPool2)"  :src="image(scope.row.Image2UrlPool2)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>									
			<el-table-column  label="池2图3" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image3UrlPool3!=null"  @click="see(scope.row.Image3UrlPool3)"  :src="image(scope.row.Image3UrlPool3)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>						
			<el-table-column prop="TemperaturePool3" label="池3水温" width="180" sortable>
			</el-table-column>
			<el-table-column prop="ChlorinePool3" label="池3余氯" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="PHPool3" label="池3PH值" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="FootPool3" label="池3浸脚池" width="180" sortable>
			</el-table-column>
			<el-table-column  label="池3图1" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrlPool3!=null"  @click="see(scope.row.ImageUrlPool3)"  :src="image(scope.row.ImageUrlPool3)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>			
			<el-table-column  label="池3图2" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image2UrlPool3!=null"  @click="see(scope.row.Image2UrlPool3)"  :src="image(scope.row.Image2UrlPool3)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>				
			<el-table-column  label="池3图3" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image3UrlPool3!=null"  @click="see(scope.row.Image3UrlPool3)"  :src="image(scope.row.Image3UrlPool3)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>			
					
			<el-table-column prop="TemperaturePool4" label="池4水温" width="180" sortable>
			</el-table-column>
			<el-table-column prop="ChlorinePool4" label="池4余氯" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="PHPool4" label="池4PH值" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="FootPool4" label="池4浸脚池" width="180" sortable>
			</el-table-column>
			<el-table-column  label="池4图1" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrlPool4!=null"  @click="see(scope.row.ImageUrlPool4)"  :src="image(scope.row.ImageUrlPool4)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>	
			<el-table-column  label="池4图2" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image2UrlPool4!=null"  @click="see(scope.row.Image2UrlPool4)"  :src="image(scope.row.Image2UrlPool4)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>						
			<el-table-column  label="池4图3" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image3UrlPool4!=null"  @click="see(scope.row.Image3UrlPool4)"  :src="image(scope.row.Image3UrlPool4)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>									
			<el-table-column prop="TemperaturePool5" label="池5水温" width="180" sortable>
			</el-table-column>
			<el-table-column prop="ChlorinePool5" label="池5余氯" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="PHPool5" label="池5PH值" width="180" sortable>
			</el-table-column>					
			<el-table-column prop="FootPool5" label="池5浸脚池" width="180" sortable>
			</el-table-column>
			<el-table-column  label="池5图1" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrlPool5!=null"  @click="see(scope.row.ImageUrlPool5)"  :src="image(scope.row.ImageUrlPool5)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>			
			<el-table-column  label="池5图2" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image2UrlPool5!=null"  @click="see(scope.row.Image2UrlPool5)"  :src="image(scope.row.Image2UrlPool5)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>				
			<el-table-column  label="池5图3" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.Image3UrlPool5!=null"  @click="see(scope.row.Image3UrlPool5)"  :src="image(scope.row.Image3UrlPool5)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>																		
			<el-table-column label="操作" width="150">
				<template  slot-scope="scope">
					<!-- <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
					<!-- <el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> --> 
			 <el-pagination class="toolbarfoot" layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>		
		</el-col>

		<el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>
	</section>
</template>
<script>
import {mapGetters} from 'vuex';
import {WaterQualityExportData,getShopInfor,WaterQualityPag,FrequencyCardComboList,WaterQualityDelete} from '../../../api/api';
export default {
	data(){
		return {
			dateValue: '',
			reportLoading:false,
			dataTypeShow:false,
			limitValue:0,
			TenancyId:'',
			shopId:'',
			optionsShop:[],
			comboId:'',
			StartDate:'',
			value:'',
			dataType:'0',
			Type:'0',
			Sort:'0',
			options:[],
			total:0,
			page:1,
			listLoading:false,
			filters:{
              name:''
			},
            PageSize:100,
			sels: [],//列表选中列
			List:[],
			imgUrl:'',
			seeImageVisible:false
		}
	},
	methods:{
		image(imageStr)
		  {

			let  imgUrl=imageStr;
              return imgUrl;
		  },
			see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },		
 		handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					WaterQualityDelete(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},       
		exportReport()
			{
				this.reportLoading=true;
			    let para = {
					Name:this.filters.Name,
					TenancyId:this.shopId,
					StartDate:this.dateValue.length>0?this.dateValue[0]:'',
					EndDate:this.dateValue.length>0?this.dateValue[1]:'' 
					};
  				let downloadName="水质监测数据";
				 WaterQualityExportData(para).then((res)=>{						 
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = downloadName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
						 this.reportLoading=false;
					 }
					 else
					 {
						 this.reportLoading=false;
					 }
		   })
			},		
		ChangeShow(){
			  if(this.dataType==1)
			  {this.dataTypeShow=true;}
			  if(this.dataType==0)
			  {this.dataTypeShow=false;}
		}, 
		 ChangeList()
         {
             console.log('1');
              this.optionList();           
         }, 
		...mapGetters(['getuserstate']),
		handleSizeChange(val){
			this.PageSize=val;
			this.page=1;
			this.getData();
		},
		optionList(){
			let para={TenancyId:this.shopId}
		  FrequencyCardComboList(para).then((res)=>{
          this.options=res.data;
				 }).catch(error=>{
				 })
		},
		handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
		selsChange: function (sels) {
				this.sels = sels;
			},
		query()
		{
		   this.page=1;
		//    if(this.StartDate=='')
		//    {
        //           this.$message({
		// 							message: '请选择查询开始日期',
		// 							type: 'error'
		// 						});	
		// 						return false;		   
		//    }
		   this.getData();
		},
		getData(){

			let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					TenancyId:this.shopId,
					StartDate:this.dateValue.length>0?this.dateValue[0]:'',
					EndDate:this.dateValue.length>0?this.dateValue[1]:'' 
				};
				this.listLoading = true;
				WaterQualityPag(para).then((res)=>{
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
				})
				.catch(error=>{
                 alert('网络错误');
                });
		},	
		getShopList()
           {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
           },               

	}
	,
		mounted() {
			this.getData();
			this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
			this.getShopList();
			// this.optionList();

		}
}
</script>



// WEBPACK FOOTER //
// WaterQualityData.vue?254003ea